export default {
    "sv-SE": {
        camera_error: "kunde inte starta kameran, förmodligen blockerad åtkomst. Prova att återställa inställningar och prova igen.",
        click_to_dismiss: "tryck för att stänga",
        cancel: "avbryt",
        confirm: "bekräfta"
    },
    "en-US": {
        camera_error: "could not start camera, probably access denied. Try resetting settings and try again.",
        click_to_dismiss: "press to dismiss",
        cancel: "cancel",
        confirm: "confirm"
    },
    "prefix": "user_input_hoc_"
};
